// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.button-with-status-container {
  display: flex;
}

.status-on-button {
  position: relative;
  bottom: 10px;
  right: 20px;
}

.action-button-reg {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  border: none;
  background: #0669B3;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  padding: 0px 20px;
  margin: 0 10px;
}
.action-button-reg:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-reg:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-80 {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  border: none;
  background: #0669B3;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  width: 80px;
  margin: 0 10px;
}
.action-button-80:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-80:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-100 {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  border: none;
  background: #0669B3;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  width: 100px;
  margin: 0 10px;
}
.action-button-100:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-100:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-150 {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  border: none;
  background: #0669B3;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  width: 150px;
  margin: 0 10px;
}
.action-button-150:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-150:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-200 {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  border: none;
  background: #0669B3;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  width: 200px;
  margin: 0 10px;
}
.action-button-200:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-200:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-delete {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  border: none;
  background: #CB321A;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  width: 250px;
  margin: 0 10px;
}
.action-button-delete:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-delete:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-delete-100 {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  border: none;
  background: #CB321A;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  width: 100px;
  margin: 0 10px;
}
.action-button-delete-100:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-delete-100:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-small-trashCan {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  background: #0669B3;
  color: white;
  height: 20px;
  transition: 0.1s ease;
  width: 40px;
  margin: 0 10px;
}
.action-button-small-trashCan:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-small-trashCan:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-cancel {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  border: none;
  background: #A7A9AC;
  height: 30px;
  transition: 0.1s ease;
  padding: 0px 20px;
  margin: 0 10px;
}
.action-button-cancel:hover {
  transform: scale(1.015);
  background: #808080;
}
.action-button-cancel:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-hide-dropdown {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  display: flex;
  justify-content: center;
  border: none;
  background: #0669B3;
  background: #A7A9AC;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  padding: 0px 20px;
  margin: 0 10px;
  width: 100%;
}
.action-button-hide-dropdown:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-hide-dropdown:disabled {
  opacity: 0.51;
  cursor: not-allowed;
}

.action-button-birthdate-reset {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  background: #0669B3;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  padding: 0px 20px;
  width: 200px;
}
.action-button-birthdate-reset:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-birthdate-reset:disabled {
  opacity: 0.51;
  cursor: not-allowed;
}

.action-button-reason {
  border-radius: 3px;
  cursor: pointer;
  display: flex;
  align-items: center;
  border: none;
  background: #0669B3;
  color: white;
  font-size: 0.9rem;
  height: 30px;
  padding: 0px 20px;
  margin: 0 10px;
  transition: 0.1s ease;
  white-space: nowrap;
}

.select-button-icon {
  display: flex;
  align-items: center;
}

@media only screen and (max-width: 1080px) {
  .action-button-reason {
    font-size: 0.7rem;
    padding: 0px 8px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/ActionButton.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;EACE,aAAA;AAUF;;AARA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;AAWF;;AARA;ECTI,kBDUsB;ECWtB,2CAAA;EDTA,eAAA;EACA,YAAA;EACA,mBDeS;ECdT,YAAA;EACA,YAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;AAWJ;AATI;EACE,uBAAA;EACA,mBDOa;ACInB;AATI;EACE,YAAA;EACA,mBAAA;AAWN;;AAPA;EC/BI,kBDgCsB;ECXtB,2CAAA;EDaA,eAAA;EACA,YAAA;EACA,mBDPS;ECQT,YAAA;EACA,YAAA;EACA,qBAAA;EACA,WAAA;EACA,cAAA;AAUJ;AARI;EACE,uBAAA;EACA,mBDfa;ACyBnB;AARI;EACE,YAAA;EACA,mBAAA;AAUN;;AAPA;ECpDI,kBDqDsB;EChCtB,2CAAA;EDkCA,eAAA;EACA,YAAA;EACA,mBD5BS;EC6BT,YAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,cAAA;AAUJ;AARI;EACE,uBAAA;EACA,mBDpCa;AC8CnB;AARI;EACE,YAAA;EACA,mBAAA;AAUN;;AAPE;ECzEE,kBD0EsB;ECrDtB,2CAAA;EDuDA,eAAA;EACA,YAAA;EACA,mBDjDS;ECkDT,YAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,cAAA;AAUJ;AARI;EACE,uBAAA;EACA,mBDzDa;ACmEnB;AARI;EACE,YAAA;EACA,mBAAA;AAUN;;AAPE;EC9FE,kBD+FsB;EC1EtB,2CAAA;ED4EA,eAAA;EACA,YAAA;EACA,mBDtES;ECuET,YAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,cAAA;AAUJ;AARI;EACE,uBAAA;EACA,mBD9Ea;ACwFnB;AARI;EACE,YAAA;EACA,mBAAA;AAUN;;AAPE;ECnHE,kBDoHsB;EC/FtB,2CAAA;EDiGA,eAAA;EACA,YAAA;EACA,mBDvGE;ECwGF,YAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,cAAA;AAUJ;AARI;EACE,uBAAA;EACA,mBDnGa;AC6GnB;AARI;EACE,YAAA;EACA,mBAAA;AAUN;;AAPE;ECxIE,kBDyIsB;ECpHtB,2CAAA;EDsHA,eAAA;EACA,YAAA;EACA,mBD5HE;EC6HF,YAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,cAAA;AAUJ;AARI;EACE,uBAAA;EACA,mBDxHa;ACkInB;AARI;EACE,YAAA;EACA,mBAAA;AAUN;;AAPE;EC7JE,kBD8JsB;ECzItB,2CAAA;ED2IA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,mBDxIS;ECyIT,YAAA;EACA,YAAA;EACA,qBAAA;EACA,WAAA;EACA,cAAA;AAUJ;AARI;EACE,uBAAA;EACA,mBDhJa;AC0JnB;AARI;EACE,YAAA;EACA,mBAAA;AAUN;;AAPE;ECrLE,kBDsLsB;ECjKtB,2CAAA;EDmKA,eAAA;EACA,YAAA;EACA,mBDnKI;ECoKJ,YAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;AAUJ;AARI;EACE,uBAAA;EACA,mBD1KE;ACoLR;AARI;EACE,YAAA;EACA,mBAAA;AAUN;;AAPE;ECzME,kBD0MsB;ECrLtB,2CAAA;EDuLA,eAAA;EACA,aAAA;EACA,uBAAA;EAEA,YAAA;EACA,mBDpLS;ECqLT,mBD3LI;EC4LJ,YAAA;EACA,YAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;AASJ;AAPI;EACE,uBAAA;EACA,mBD9La;ACuMnB;AAPI;EACE,aAAA;EACA,mBAAA;AASN;;AANE;ECnOE,kBDoOsB;EC/MtB,2CAAA;EDiNA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,YAAA;EACA,mBD/MS;ECgNT,YAAA;EACA,YAAA;EACA,qBAAA;EACA,iBAAA;EACA,YAAA;AAQJ;AANI;EACE,uBAAA;EACA,mBDvNa;AC+NnB;AANI;EACE,aAAA;EACA,mBAAA;AAQN;;AAJE;EC7PE,kBD8PsB;EACtB,eAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,mBDtOS;ECuOT,YAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;EACA,mBAAA;AAOJ;;AALE;EACE,aAAA;EACA,mBAAA;AAQJ;;AALE;EACE;IACE,iBAAA;IACA,gBAAA;EAQJ;AACF","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// Guardian Dashboard colors\n$lt-blue: #7DB7CC;\n$dk-blue: #19608f;\n\n$error: #CE3525;\n$error-dk: #aa3333;\n$error-hover: #cf4635;\n$hover-white: #E0E0E0;\n$light-background: #EFEFEF;\n\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$green: #4a8319;\n\n$important: #FEBF31;\n$grey0: #EDf0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pale-blue: #C0DEF0;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n$icon-blue: #4DD9FF;\n","@import \"../styles/global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n.button-with-status-container {\n  display: flex\n}\n.status-on-button {\n  position: relative;\n  bottom: 10px;\n  right: 20px\n}\n\n.action-button-reg {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    border: none;\n    background: $pearl-blue;\n    color: white;\n    height: 30px;\n    transition: 0.1s ease;\n    padding: 0px 20px;\n    margin: 0 10px;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $pearl-blue-hover;\n    }\n    &:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n  };\n\n.action-button-80 {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    border: none;\n    background: $pearl-blue;\n    color: white;\n    height: 30px;\n    transition: 0.1s ease;\n    width: 80px;\n    margin: 0 10px;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $pearl-blue-hover;\n    }\n    &:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n  };\n.action-button-100 {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    border: none;\n    background: $pearl-blue;\n    color: white;\n    height: 30px;\n    transition: 0.1s ease;\n    width: 100px;\n    margin: 0 10px;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $pearl-blue-hover;\n    }\n    &:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n  };\n  .action-button-150 {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    border: none;\n    background: $pearl-blue;\n    color: white;\n    height: 30px;\n    transition: 0.1s ease;\n    width: 150px;\n    margin: 0 10px;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $pearl-blue-hover;\n    }\n    &:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n  };\n  .action-button-200 {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    border: none;\n    background: $pearl-blue;\n    color: white;\n    height: 30px;\n    transition: 0.1s ease;\n    width: 200px;\n    margin: 0 10px;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $pearl-blue-hover;\n    }\n    &:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n  };\n  .action-button-delete {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    border: none;\n    background: $red;\n    color: white;\n    height: 30px;\n    transition: 0.1s ease;\n    width: 250px;\n    margin: 0 10px;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $pearl-blue-hover;\n    }\n    &:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n  };\n  .action-button-delete-100 {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    border: none;\n    background: $red;\n    color: white;\n    height: 30px;\n    transition: 0.1s ease;\n    width: 100px;\n    margin: 0 10px;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $pearl-blue-hover;\n    }\n    &:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n  };\n  .action-button-small-trashCan {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border: none;\n    background: $pearl-blue;\n    color: white;\n    height: 20px;\n    transition: 0.1s ease;\n    width: 40px;\n    margin: 0 10px;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $pearl-blue-hover;\n    }\n    &:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n  };\n  .action-button-cancel {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    border: none;\n    background: $grey2;\n    height: 30px;\n    transition: 0.1s ease;\n    padding: 0px 20px;\n    margin: 0 10px;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $grey3;\n    }\n    &:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n  };\n  .action-button-hide-dropdown {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n\n    border: none;\n    background: $pearl-blue;\n    background: $grey2;\n    color: white;\n    height: 30px;\n    transition: 0.1s ease;\n    padding: 0px 20px;\n    margin: 0 10px;\n    width: 100%;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $pearl-blue-hover;\n    }\n    &:disabled {\n      opacity: .51;\n      cursor: not-allowed;\n    }\n  };\n  .action-button-birthdate-reset {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    border: none;\n    background: $pearl-blue;\n    color: white;\n    height: 30px;\n    transition: 0.1s ease;\n    padding: 0px 20px;\n    width: 200px;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $pearl-blue-hover;\n    }\n    &:disabled {\n      opacity: .51;\n      cursor: not-allowed;\n    }\n  };\n\n  .action-button-reason {\n    @include borderRadius(3px);\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    border: none;\n    background: $pearl-blue;\n    color: white;\n    font-size: 0.9rem;\n    height: 30px;\n    padding: 0px 20px;\n    margin: 0 10px;\n    transition: 0.1s ease;\n    white-space: nowrap;\n  };\n  .select-button-icon {\n    display: flex;\n    align-items: center;\n  }\n\n  @media only screen and (max-width: 1080px) {\n    .action-button-reason {\n      font-size: 0.7rem;\n      padding: 0px 8px;\n    }\n  }\n","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowCustom($hor: 1px, $vert: 1px, $blur: 2px, $color: $shadow) {\n    box-shadow: $hor $vert $blur $color;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
